import { HeadLine } from '../../../layouts/headers/HeadLine'
import SimpleAccordion from '../components/SimpleAccordion';

export const Security = () => {

    const rules = [
        {
            icon: 'parking-icon.svg',
            title: 'Estacionamiento',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        },
        {
            icon: 'fire-icon.svg',
            title: 'Fuego',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        },
        {
            icon: 'pool-icon.svg',
            title: 'Piscina y Playa',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        },
        {
            icon: 'wave-icon.svg',
            title: 'Advertencia en Mar',
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ornare, dui facilisis imperdiet mattis, turpis velit porttitor turpis, sit amet blandit lorem risus eu urna. Integer elit massa, tristique at eros nec, viverra mattis orci.'
        }
    ];

    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Info de seguridad y emergencias' backurl='/hotel-info' />
            </div>

            <div className='w-full relative content-hi-sm'>
                <SimpleAccordion items={rules} />
            </div>
        </>
    )
}
